import { ConnectiveLoginService } from './../../../core/services/connective-login.service';
import { QuestionLoginComponent } from './../../../shared/components/question-login/question-login.component';
import { Component, OnInit, NgZone, ViewChild, ElementRef, OnDestroy, AfterViewInit, Output, EventEmitter, HostListener } from '@angular/core';
import { Credentials } from 'src/app/core/models/credentials';
import { Router, ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { first, takeUntil } from 'rxjs/operators';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/auth/auth.service';
import { LoginBase } from '../login-base';
import { RecaptchaComponent } from 'ng-recaptcha';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../../core/services/common.service';
import { HyperLink } from 'src/app/core/constants/hyperlink';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { TimeoutSessionService } from 'src/app/core/services/timeout-session.service';
import { WarningHasTokenComponent } from 'src/app/shared/components/warning-has-token/warning-has-token.component';
import { SelectVersionComponent } from '../../../shared/components/select-version/select-version.component'
import { RSA_PKCS1_OAEP_PADDING } from 'constants';
import { getJSDocReturnType } from 'typescript';
import {NotificationCmsService} from "../../../core/services/notification-cms.service";
import { ErrorCode } from 'src/app/core/constants/error-code';
import { AnonymousSignService } from 'src/app/core/services/anonymous-sign.service';
import { ToastrService } from 'ngx-toastr';
import { LinkAccountService } from 'src/app/core/services/link-account.service';
import {LINK_TYPE} from '../../dashboard/home/home-enterprise/link-account/utilities/link-type.enum';

declare function changeRecaptchaLanguage(language): any;

declare function resetRecaptchaValue(callback): any;

declare function resetRecaptchaStatus(language): any;


@Component({
  selector: 'app-login-enterprise',
  templateUrl: './login-enterprise.component.html',
  styleUrls: ['./login-enterprise.component.scss'],
})

/*
 * <pre>
 * <b>Class name: LoginEnterpriseComponent</b>
 * <b>Explanation:</b> Component Login Enterprise
 * <b>Creation date:</b> 2019/08/25
 * </pre>
 *
 * @author GCS 2019/07/01 by linhdh
 **/
export class LoginEnterpriseComponent extends LoginBase implements OnInit, OnDestroy, AfterViewInit {
  /**
   * the block ui.
   */
  @BlockUI() blockUI: NgBlockUI;
  public phoneNumber: string = '';
  currentLanguage = 'vi';

  signin = new FormGroup({
    email: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required),
    captcha: new FormControl(),
  });
  loginForm: FormGroup;

  // Variables for showing re captcha
  failedLoginCount: any;
  limitFailedLoginNoReCaptcha = 4;
  showReCaptchaRequiredErr = false;

  credentials: Credentials = new Credentials('', false);
  errorMessage = '';
  isRemember: boolean;
  autoLogout = false;
  username: string;
  password: string;
  captcha: string;
  error = '';
  subscription: Subscription;
  invalidLogin = false;
  passwordVisibility = false;
  id = 1;
  passwordExpired = false;
  private dialogRef: any;

  //update login 29/10
  erpToken: string;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;

  // @ViewChild('btnLogin', { static: false }) focusEl: ElementRef;

  @ViewChild(RecaptchaComponent, { static: false })
  public reCaptcha: RecaptchaComponent;
  @Output() changeLanguage = new EventEmitter<boolean>();

  dataUrlState: any;
  isRejectLogin:boolean = false;

  mode: string = 'LOGIN' || 'SEARCH_CLOUD_CA' || 'SIGN';
  dataLogin: any;
  client_id: string = ''
  GOOGLE_AUTH_URL: string = ''
  ZALO_AUTH_URL: string = ''
  redirect_uri : string = ''
  slideCaptcha : any;
  loginMode: 'GOOGLE' | 'ZALO' | 'APPLE' | 'FACEBOOK' = 'GOOGLE';
  queryParams: any = {};
  redirectType: string = '';
  LINK_TYPE = LINK_TYPE;
  dataInfoSso: any;
  /**
   * <pre>
   * <b>Method name: constructor</b>
   * <b>Explanation: </b> Method constructor
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private authSer: AuthService,
    private notificationService: NotificationService,
    // private dialogRef: MatDialog,
    private message: Message,
    private translate: TranslateService,
    public commonService: CommonService,
    private toastr: ToastrService,

    //update login 29/10
    private activeRouter: ActivatedRoute,
    public dialog: MatDialog,
    private connectiveLoginService: ConnectiveLoginService,
    private timeSessionService: TimeoutSessionService,
    public notificationCmsService: NotificationCmsService,
    private anonymousSignService: AnonymousSignService,
    private ggAccountSrv: LinkAccountService,
    private ngZone: NgZone
  ) {
    super();
    this.phoneNumber = HyperLink.PHONE_NUMBER;
    this.dataUrlState = this.router.getCurrentNavigation().extras.state;
    localStorage.removeItem('entType');
    this.commonService.entTypeChange.next(true);
    //update login 29/10
    this.activeRouter.queryParams.subscribe(params => {
      if (params['erp_token']) {
        this.erpToken = params['erp_token'];
      }
    })

    const fragment = window.location.hash.substring(1);
    const params = new URLSearchParams(fragment);

    const idToken = params.get('id_token');

    if (idToken) {
      if (this.failedLoginCount > this.limitFailedLoginNoReCaptcha && this.slideCaptcha == null) {
        this.showReCaptchaRequiredErr = true;
        return;
      }
      if (this.erpToken) {
        this.loginErp();
      } else {
        this.authService.loginWithGoogle({tokenGoogle: idToken},this.isRemember).subscribe(res =>{
          window.history.replaceState({}, document.title, window.location.pathname)
          if(res.success){
            this.afterLoginWithGG(res)
          } else {
            if (
              res.code == ErrorCode.GOOGLE_LOGIN_TOKEN_INVALID ||
              res.code == ErrorCode.GOOGLE_LOGIN_ACCOUNT_HAS_LINKED ||
              res.code == ErrorCode.GOOGLE_LOGIN_EMAIL_EXIST ||
              res.code == ErrorCode.GOOGLE_LOGIN_ACCOUNT_HAS_LINKED ||
              res.code == ErrorCode.GOOGLE_LOGIN_USER_INVALID ||
              res.code == ErrorCode.GOOGLE_LOGIN_REFERENCE_INVALID ||
              res.code == ErrorCode.GOOGLE_LOGIN_APP_PARAM_INVALID
            ) {
              toastr.error(res.message)
            }
          }
        })
      }
    }
    //check login with zalo
    this.activeRouter.queryParamMap.subscribe(params => {
      this.redirectType = params.get('type');
      const code = params.get('code');
      const state = params.get('state');
      if(code && state) {
        this.queryParams = {
          code,
          state,
        };
        this.authService.loginWithZalo(this.queryParams,this.isRemember).subscribe(res =>{
          window.history.replaceState({}, document.title, window.location.pathname)
          if(res.success){
            this.afterLoginWithGG(res)
          } else {
            if (
              res.code == ErrorCode.GOOGLE_LOGIN_TOKEN_INVALID ||
              res.code == ErrorCode.GOOGLE_LOGIN_ACCOUNT_HAS_LINKED ||
              res.code == ErrorCode.GOOGLE_LOGIN_EMAIL_EXIST ||
              res.code == ErrorCode.GOOGLE_LOGIN_ACCOUNT_HAS_LINKED ||
              res.code == ErrorCode.GOOGLE_LOGIN_USER_INVALID ||
              res.code == ErrorCode.GOOGLE_LOGIN_REFERENCE_INVALID ||
              res.code == ErrorCode.GOOGLE_LOGIN_APP_PARAM_INVALID
            ) {
              toastr.error(res.message)
            }
          }
        })
      }
    })
  }
  private unsubscriber : Subject<void> = new Subject<void>();

  /**
   * <pre>
   * <b>Method name: ngOnInit</b>
   * <b>Explanation: </b> Method initial
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  ngOnInit() {
    history.pushState(null, '');
    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
      this.mode = 'LOGIN';
      this.authService.logout();
    });
    this.mode = 'LOGIN';
    this.currentLanguage = localStorage.getItem('__language');
    if (!this.currentLanguage) {
      this.currentLanguage = 'vi';
    }

    // localStorage.clear();
    sessionStorage.clear();

    // re-saving language.
    localStorage.setItem('__language', this.currentLanguage);

    this.checkLoginFail();
    this.notificationService.subscribeErrorService();
    resetRecaptchaValue((rcVal) => {
      this.captcha = rcVal;
      this.showReCaptchaRequiredErr = false;
    });

    this.getInfoVneidSso();
    // this.loadCities();
    // this.loadDistricts();
    // setTimeout(() => {
    //   this.dialogRef = this.dialog.open(SelectVersionComponent, {
    //     width: '40%',
    //     disableClose: true
    //   });
    //   this.dialogRef.afterClosed().subscribe(rs => {
    //     console.log('rs', rs)
    //   })
    // }, 500);

    // this.ggAccountSrv.getGoogleInfo({code: 'google.client_id'}).subscribe(res => {
    //   this.client_id = res.data.value
    //   this.getLoginUrl()
    // })
    // this.ggAccountSrv.getGoogleInfo({code: 'google.redirect_url'}).subscribe(res => {
    //   this.redirect_uri = res.data.value
    //   this.getLoginUrl()
    // })
    // this.ggAccountSrv.getZaloInfo({code: 'zalo.client_id'}).subscribe(res => {
    //   this.client_id = res.data.value
    //   this.getLoginZaloUrl()
    // })
    // this.ggAccountSrv.getZaloInfo({code: 'zalo.redirect_url'}).subscribe(res => {
    //   this.redirect_uri = res.data.value
    //   this.getLoginZaloUrl()
    // })
  }

  /**
   * On destroy component
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  /**
   * <pre>
   * <b>Method name: login</b>
   * <b>Explanation: </b> Method login
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */

  login() {
    if (this.failedLoginCount > this.limitFailedLoginNoReCaptcha && this.slideCaptcha == null) {
      this.showReCaptchaRequiredErr = true;
      return;
    }

    if (this.erpToken) {
      this.loginErp();
    } else {
      this.authService.login('/auth/login',
        this.username.trim(), this.password, this.isRemember, this.slideCaptcha, false).pipe(first()).subscribe(
          res => {
            if (res.success) {
               this.dataLogin = res.data;
              /**
               * Nếu có giá trị userService.isDefault == false | không tồn tại thì chưa set default
               * Nếu giá trị userService.isDefault == true thì tiến hành đăng nhập luôn
              */
              if (this.dataLogin.isTwoFactorAuthen) {
                this.anonymousSignService.timeWaitSign.next(this.dataLogin.timeWaitSign);
                this.authService.getListCloudCertificate().subscribe(rs => {
                  console.log(rs);
                  if (rs && rs.data.length > 0) {
                    this.anonymousSignService.selectedCert.next(rs.data[0]);
                    this.mode = 'SIGN';
                  } else {
                    this.mode = 'SEARCH_CLOUD_CA';
                  }
                })
                return;
              }
              localStorage.setItem('userServices', JSON.stringify(this.dataLogin.userService.userServices || []))
              if (this.dataLogin.userService && !this.dataLogin.userService.isDefault && this.dataLogin.userService.userServices && this.dataLogin.userService.userServices.length >= 2) {
                sessionStorage.setItem('selectModeYet', 'false');
                this.dialogRef = this.dialog.open(SelectVersionComponent, {
                  width: '40%',
                  disableClose: true,
                  data: {
                    userServices: this.dataLogin.userService.userServices,
                    isLogin: true
                  }
                });
                this.dialogRef.afterClosed().subscribe(rs => {
                  if (rs && rs.success) {
                    sessionStorage.removeItem('selectModeYet')
                    this.afterLogin(rs.data)
                  }
                })
              } else {
                this.afterLogin(this.dataLogin)
              }
            } else {
              if (res.code === ErrorCode.NOT_IP_CONFIG) {
                this.isRejectLogin = true;
              } else {
                this.toastr.error(this.message.getMessage('messages.wrong_credential'));
              }
              this.slideCaptcha = null;
              this.authSer.removeToken();
              localStorage.removeItem('tenantId');
              localStorage.removeItem('userId');
              localStorage.removeItem('fullName');
              localStorage.removeItem('userName');
              localStorage.removeItem('enterpriseId');
              localStorage.removeItem('userType');
              localStorage.removeItem('permissions');
              localStorage.removeItem('defaultPermission');
              localStorage.removeItem('isParent');
              localStorage.removeItem('currentModule');
              localStorage.removeItem('isFromSSO');
              localStorage.removeItem('userServices');
              localStorage.removeItem('isAdminDefault');
              this.invalidLogin = true;

              // && this.reCaptcha.reset();
              document.getElementById('username').focus();

              // console.log(this.failedLoginCount);
              // console.log(this.limitFailedLoginNoReCaptcha);
              if (this.failedLoginCount >= this.limitFailedLoginNoReCaptcha) {
                resetRecaptchaStatus(this.currentLanguage);
              }

              // setTimeout(() => {changeRecaptchaLanguage(localStorage.getItem('__language'));}, 100)
            }
          }
        )
    }
  }

  afterLogin(res) {
    // return
    this.passwordExpired = res.passwordExpired;
    localStorage.setItem('passwordExpired', JSON.stringify(this.passwordExpired));
    localStorage.setItem('dayToExpire', JSON.stringify(res.dayToExpire));
    localStorage.setItem('numberDayShowWarningPassword', JSON.stringify(res.numberDayShowWarningPassword));
    localStorage.setItem('isParent', res.isParent);
    localStorage.setItem('isAdminDefault', res.isAdminDefault);
    localStorage.setItem('userType', res.userType);
    localStorage.setItem('lastChangePassword', res.lastChangePassword);
    localStorage.setItem('isFromSSO', res.isFromSSO);

    if (!res.isVerify) {
      this.redirectAfterLogin('kyc-confirm-account', null)
      return;
    }
    if (res.userType != 0) {
      localStorage.setItem("permissions", JSON.stringify(res.permissions));
      if (this.isRemember === true) {
        this.credentials = new Credentials(this.username, this.isRemember);
        localStorage.setItem('credentialsEnt', JSON.stringify(this.credentials));
      } else {
        localStorage.removeItem('credentialsEnt');
      }

      if (res.userType != 0) {
        localStorage.setItem("permissions", JSON.stringify(res.permissions));
        if (this.isRemember === true) {
          this.credentials = new Credentials(this.username, this.isRemember);
          localStorage.setItem('credentialsEnt', JSON.stringify(this.credentials));
        } else {
          localStorage.removeItem('credentialsEnt');
        }
        if (res.approverNumber) {
          localStorage.setItem('approverNumber', res.approverNumber);
        } else {
          localStorage.removeItem('approverNumber');
        }
        // entType === 2: Loại không chứng thực
        if (res.entType !== undefined) {
          localStorage.setItem('entType', res.entType);
        } else {
          localStorage.removeItem('entType');
        }
        this.commonService.entTypeChange.next(true);
        // this.router.navigate(['home-enterprise']);
      } else {
        this.slideCaptcha = null;
        this.toastr.error(this.message.getMessage('messages.wrong_credential'));
        this.authSer.removeToken();
        localStorage.removeItem('tenantId');
        localStorage.removeItem('userId');
        localStorage.removeItem('fullName');
        localStorage.removeItem('userName');
        localStorage.removeItem('enterpriseId');
        localStorage.removeItem('userType');
        localStorage.removeItem('permissions');
        localStorage.removeItem('defaultPermission');
        localStorage.removeItem('isParent');
        localStorage.removeItem('currentModule');
        localStorage.removeItem('SignDataValidate');
        localStorage.removeItem('cloudCaMultiSignThreshold');
        localStorage.removeItem('userServices');
        localStorage.removeItem('isFromSSO');
        localStorage.removeItem('lastChangePassword');
        this.invalidLogin = true;
      }
      // this.redirectAfterLogin('home-enterprise', null)

    } else {
      this.slideCaptcha = null;
      this.toastr.error(this.message.getMessage('messages.wrong_credential'));
      this.authSer.removeToken();
      localStorage.removeItem('tenantId');
      localStorage.removeItem('userId');
      localStorage.removeItem('fullName');
      localStorage.removeItem('userName');
      localStorage.removeItem('enterpriseId');
      localStorage.removeItem('userType');
      localStorage.removeItem('permissions');
      localStorage.removeItem('defaultPermission');
      localStorage.removeItem('isParent');
      localStorage.removeItem('currentModule');
      localStorage.removeItem('userServices');
      localStorage.removeItem('isFromSSO');
      localStorage.removeItem('lastChangePassword');
      this.invalidLogin = true;
    }
    this.redirectAfterLogin('home-enterprise', { state: this.dataUrlState });
    this.notificationCmsService.getNotification();
  }

  getInfoVneidSso() {
    this.ggAccountSrv.getGoogleInfo({code: 'vneid_sso'}).subscribe(res => {
      if (res.success) {
         this.dataInfoSso = JSON.parse(res.data.value);
      }
    })
  }

  /**
   * <pre>
   * <b>Method name: keyDownFunction</b>
   * <b>Explanation: </b> Method get event key down
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  // keyDownFunction(event) {
  //   if (event.keyCode == 13) {
  //     this.focusEl.nativeElement.focus();
  //     this.login();
  //   }
  // }

  checkLoginFail() {
    this.authService.checkLoginFail().subscribe(rs => {
      this.failedLoginCount = rs.data;
    }
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // this.dialogRef.closeAll();
      this.dialog.closeAll();
    }, 1000);
    // this.loadWards();
  }

  /**
   * Check form valid username, password and reCaptcha (If have)
   */
  isFormValid(): boolean {
    if (this.ngForm.invalid) {
      if (this.failedLoginCount && this.failedLoginCount > this.limitFailedLoginNoReCaptcha) {
        this.showReCaptchaRequiredErr = true;
      }
      return false;
    } else {
      return true;
    }
  }

  /**
   * Method name: onChangeLanguage
   */
  onChangeLanguage(languageSelected: string) {
    this.currentLanguage = languageSelected;

    // start waiting.
    this.blockUI.reset();
    this.blockUI.start('');
    this.onCheckBlockUI();

    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
    changeRecaptchaLanguage(languageSelected);
  }

  /**
   * Get cities list from local storage or api
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
    this.getCities().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        localStorage.setItem(
          'cities',
          JSON.stringify(data),
        );
      }
    });
    // }
  }

  /**
   * Get districts list from local storage or api
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
    this.getDistricts().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        localStorage.setItem(
          'districts',
          JSON.stringify(data),
        );
      }
    });
    // }
  }

  /**
   * Get wards list from local storage or api
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
    this.getWards().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        localStorage.setItem(
          'wards',
          JSON.stringify(data),
        );
      }
    });
    // }
  }

  getCities() {
    return this.commonService.getAllCity();
  }

  getDistricts() {
    return this.commonService.getAllDistricts();
  }

  getWards() {
    return this.commonService.getAllWard();
  }

  /**
   * Check block UI.
   */
  private onCheckBlockUI() {
    localStorage.setItem('blockUI', '1');
    const timerId = setInterval(() => {
      if (localStorage.getItem('blockUI') == '0') {
        this.blockUI.stop();
        clearInterval(timerId);
        localStorage.removeItem('blockUI');
      }
    }, 1000);
  }

  questionUserLogin() {
    const dialogRe = this.dialog.open(QuestionLoginComponent, {
      width: '550px',
      maxWidth: '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: { formType: 'login-erp' }
    });
    dialogRe.afterClosed().subscribe(data => {
      if (data) {
        this.connectiveLoginService.connectiveLogin(this.erpToken, true).subscribe(response => {
        });
      } else {
        this.connectiveLoginService.connectiveLogin(this.erpToken, false).subscribe(response => {
        });
      }
      if (this.isRemember === true) {
        this.credentials = new Credentials(this.username, this.isRemember);
        localStorage.setItem('credentialsEnt', JSON.stringify(this.credentials));
      } else {
        localStorage.removeItem('credentialsEnt');
      }
      this.router.navigate(['home-enterprise']);
    })
  }

  questionUserLoginError() {
    const dialogRe = this.dialog.open(QuestionLoginComponent, {
      width: '550px',
      maxWidth: '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: { formType: 'login-erp-error' }
    });
    dialogRe.afterClosed().subscribe(data => {
      this.router.navigate(['home-enterprise']);
    })
  }


  loginErp() {
    this.authService.loginErp('/auth/login-erp',
      this.username.trim(), this.password, this.isRemember, this.slideCaptcha, false, this.erpToken).pipe(first()).subscribe(
        res => {
          if (res) {
            if (res.userType != 0) {
              if (localStorage.getItem('userId')) {
                this.authService.getPermissionInfo().subscribe(() => { }, () => { });
              }
              if (res.isSameErpToken) {
                this.questionUserLogin();
              } else {
                this.questionUserLoginError();
              }
              if (res.approverNumber) {
                localStorage.setItem('approverNumber', res.approverNumber);
              } else {
                localStorage.removeItem('approverNumber');
              }
            } else {
              this.slideCaptcha = null;
              this.toastr.error(this.message.getMessage('messages.wrong_credential'));
              this.authSer.removeToken();
              localStorage.removeItem('tenantId');
              localStorage.removeItem('userId');
              localStorage.removeItem('fullName');
              localStorage.removeItem('userName');
              localStorage.removeItem('enterpriseId');
              localStorage.removeItem('userType');
              localStorage.removeItem('permissions');
              localStorage.removeItem('defaultPermission');
              localStorage.removeItem('isParent');
              localStorage.removeItem('currentModule');
              localStorage.removeItem('SignDataValidate');
              localStorage.removeItem('approverNumber');
              localStorage.removeItem('isFromSSO');
              this.invalidLogin = true;
            }
          }
        },
        error => {
          this.failedLoginCount = localStorage.getItem('count_login_failed');
          localStorage.removeItem('count_login_failed');
          if (!this.failedLoginCount || this.failedLoginCount == 0) {
            this.failedLoginCount = 1;
          }
          this.invalidLogin = true;
          this.slideCaptcha = null;
          document.getElementById('username').focus();
          if (this.failedLoginCount >= this.limitFailedLoginNoReCaptcha) {
            resetRecaptchaStatus(this.currentLanguage);
          }
        }
      );
  }

  redirectAfterLogin(type, option: any) {
    // Pre-fetch permission-info: AuthGuard o moi route doc tu cache thay vi goi HTTP
    // (cache chot theo userId|enterpriseId|userType; logout/change-mode tu invalidate)
    if (localStorage.getItem('userId')) {
      this.authService.getPermissionInfo().subscribe(() => { }, () => { });
    }
    if (this.passwordExpired) {
      this.router.navigate(['reset-password']);
    }
    else {
      if (option) {
        this.router.navigate([type], option)
      }
      else {
        this.router.navigate([type])
      }
    }
  }
  onChangeAction(data:any) {
    if (data) {
      this.mode = data;
    }
  }
  afterVerifyTwoAuthen(isVerify:boolean) {
    if (isVerify) {
      localStorage.setItem('userServices', JSON.stringify(this.dataLogin.userService.userServices || []))
      if (this.dataLogin.userService && !this.dataLogin.userService.isDefault && this.dataLogin.userService.userServices && this.dataLogin.userService.userServices.length >= 2) {
        sessionStorage.setItem('selectModeYet', 'false');
        this.dialogRef = this.dialog.open(SelectVersionComponent, {
          width: '40%',
          disableClose: true,
          data: {
            userServices: this.dataLogin.userService.userServices,
            isLogin: true
          }
        });
        this.dialogRef.afterClosed().subscribe(rs => {
          if (rs && rs.success) {
            sessionStorage.removeItem('selectModeYet');
            this.afterLogin(rs.data);
          }
        })
      } else {
        this.afterLogin(this.dataLogin)
      }
    }
  }
  changeMode(data:any) {
    if (data) {
      this.mode = data;
    }
  }

  onLogin(mode: string){
    switch (mode) {
      case LINK_TYPE.ZALO: {
        this.commonService.generateChallengeCodeAndState()
          .subscribe((res: any) => {
              console.log(res)
              if(res && res.success && res.data) {
                const data = res.data;
                const callbackUrl = `${res.data.callBackUrl}/enterprise-login?type=ZALO`
                const zaloUrl = 'https://oauth.zaloapp.com/v4/permission?';
                this.ZALO_AUTH_URL = `${zaloUrl}redirect_uri=${callbackUrl}&app_id=${data.zaloAppId}&code_challenge=${data.codeChallenge}&state=${data.state}&code=${data.codeChallenge}`
                console.log(this.ZALO_AUTH_URL)
                window.location.href = this.ZALO_AUTH_URL
              }
              else {
                this.toastr.error(this.message.getMessage('messages.update_certificate_renew_server_error'))
              }
            },
            error => {
              this.toastr.error(this.message.getMessage('messages.update_certificate_renew_server_error'))
            })
        break;
      }
      case LINK_TYPE.GOOGLE: {
        this.loginWithGoogle();
        break;
      }
      case LINK_TYPE.APPLE: {
        this.loginWithApple();
        break;
      }
      case LINK_TYPE.FACEBOOK: {
        this.loginWithFacebook();
        break;
      }
    }
  }

  loginWithGoogle() {
    this.ggAccountSrv.loginWithGoogle().then(async res => {
      if(res.user){
        const idToken = await res.user.getIdToken();
        this.ngZone.run(() => {
          this.loginWithFireBase(idToken);
          this.logoutFirebase();
        });
      }
    });
  }

  loginWithFacebook() {
    this.ggAccountSrv.loginWithFacebook().then(async res => {
      if(res.user){
        const idToken = await res.user.getIdToken();
        this.ngZone.run(() => {
          this.loginWithFireBase(idToken);
          this.logoutFirebase();
        });
      }
    });
  }

  loginWithApple() {
    this.ggAccountSrv.loginWithApple().then(async res => {
      if(res.user){
        const idToken = await res.user.getIdToken();
        this.ngZone.run(() => {
          this.loginWithFireBase(idToken);
          this.logoutFirebase();
        });
      }
    });
  }

  logoutFirebase(){
    this.ggAccountSrv.logoutFirebase();
  }

  // Login with FireBase

  loginWithFireBase(idToken: any){
    this.authService.loginFirebase( '/auth/login-with-social',{idToken: idToken},this.isRemember).pipe(first()).subscribe(res =>{
      console.log(res)
      this.afterLoginWithGG(res);
      this.logoutFirebase()
    }, (error: any) => {
      console.log(error)
    })
  }

  getLoginUrl(){
    if(this.client_id && this.redirect_uri){
      const params: any = new URLSearchParams({
        client_id: this.client_id,
        redirect_uri: this.redirect_uri+'/enterprise-login',
        response_type: 'id_token',
        scope: 'openid email profile',
        nonce: this.generateRandomString(32),
        state: this.generateRandomString(16),
        prompt: 'select_account'
      });

      this.GOOGLE_AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`
    }
  }

  generateRandomString(length: number){
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  };

  afterLoginWithGG(res: any){
    if (res.success) {
      this.dataLogin = res.data;
     /**
      * Nếu có giá trị userService.isDefault == false | không tồn tại thì chưa set default
      * Nếu giá trị userService.isDefault == true thì tiến hành đăng nhập luôn
     */
     if (this.dataLogin.isTwoFactorAuthen) {
       this.anonymousSignService.timeWaitSign.next(this.dataLogin.timeWaitSign);
       this.authService.getListCloudCertificate().subscribe(rs => {
         console.log(rs);
         if (rs && rs.data.length > 0) {
           this.anonymousSignService.selectedCert.next(rs.data[0]);
           this.mode = 'SIGN';
         } else {
           this.mode = 'SEARCH_CLOUD_CA';
         }
       })
       return;
     }
     localStorage.setItem('userServices', JSON.stringify(this.dataLogin.userService.userServices || []))
     if (this.dataLogin.userService && !this.dataLogin.userService.isDefault && this.dataLogin.userService.userServices && this.dataLogin.userService.userServices.length >= 2) {
       sessionStorage.setItem('selectModeYet', 'false');
        setTimeout(()=>{
          this.dialogRef = this.dialog.open(SelectVersionComponent, {
            width: '40%',
            disableClose: true,
            data: {
              userServices: this.dataLogin.userService.userServices,
              isLogin: true
            }
          });
          this.dialogRef.afterClosed().subscribe(rs => {
            if (rs && rs.success) {
              sessionStorage.removeItem('selectModeYet')
              this.afterLogin(rs.data)
            }
          })
        },1002)
     } else {
       this.afterLogin(this.dataLogin)
     }
   } else {
     if (res.code === ErrorCode.NOT_IP_CONFIG) {
       this.isRejectLogin = true;
     } else {
        this.toastr.error(res.message);
     }
     this.slideCaptcha = null;
     this.authSer.removeToken();
     localStorage.removeItem('tenantId');
     localStorage.removeItem('userId');
     localStorage.removeItem('fullName');
     localStorage.removeItem('userName');
     localStorage.removeItem('enterpriseId');
     localStorage.removeItem('userType');
     localStorage.removeItem('permissions');
     localStorage.removeItem('defaultPermission');
     localStorage.removeItem('isParent');
     localStorage.removeItem('currentModule');
     localStorage.removeItem('isFromSSO');
     localStorage.removeItem('userServices');
     localStorage.removeItem('isAdminDefault');
     this.invalidLogin = true;

     // && this.reCaptcha.reset();
     document.getElementById('username').focus();

     // console.log(this.failedLoginCount);
     // console.log(this.limitFailedLoginNoReCaptcha);
     if (this.failedLoginCount >= this.limitFailedLoginNoReCaptcha) {
       resetRecaptchaStatus(this.currentLanguage);
     }

     // setTimeout(() => {changeRecaptchaLanguage(localStorage.getItem('__language'));}, 100)
   }
  }
  handleCaptcha(data:string) {
    console.log(data);
    this.slideCaptcha = data;
  }

  getCurrentNameLanguage(): string{
    switch(this.currentLanguage){
      case 'vi':
        return 'Tiếng Việt';
      case 'en':
        return 'English';
      case 'zh':
        return '中国人';
      case 'es':
        return 'Español';
      default:
        return 'Español'
    }
  }
  isOpen: boolean = false;

  featureInDevelopment(){
    this.toastr.error(this.message.getMessage('link_google_acount.feature_in_development'))
  }

  redirectToVneid() {
    if (this.dataInfoSso.enable_login_vneid !== "true") {
      this.toastr.error(this.message.getMessage('link_google_acount.feature_in_development'));
      return;
    }
    const redirectUri = this.dataInfoSso.redirect_uri; 
    const redirectUrl = `${this.dataInfoSso.URL_SSO}/auth` 
    + `?response_type=${this.dataInfoSso.response_type}` 
    + `&client_id=${this.dataInfoSso.client_id}` 
    + `&scope=${this.dataInfoSso.openid}` 
    + `&redirect_uri=${redirectUri}`; 
      window.location.assign(redirectUrl);
  }
}
